import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { disableSomeContentStyles } from 'styles/mixins'

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
`

export const SwapButton = styled.button<{ $disabled?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  border: 1px solid ${COLORS.borderColor};
  background: ${COLORS.white};
  cursor: pointer;
  transition:
    opacity 0.2s ease,
    background 0.2s ease;

  & > svg {
    width: 14px;
    height: 14px;

    path {
      fill: ${COLORS.secondarySemiDark};
    }
  }

  ${({ $disabled }) => $disabled && disableSomeContentStyles()}

  &:hover {
    background: ${COLORS.secondaryUltraLight};
  }
`
